import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions'
import {TOAST_SHOW_DURATION} from '../../util/Constants'
import { Alert, Slide, Snackbar } from '@mui/material';

export default function ErrorToast() {
  const open = useSelector(state => state.GlobalReducer.errorToastOpen)
  const msg  = useSelector(state => state.GlobalReducer.errorMessage)
  const [vertical] = useState('top');
  const [horizontal] = useState('center');
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    dispatch({type : actions.HIDE_ERROR_TOAST});
  };

  return (
    <div>
      <Snackbar anchorOrigin={{ vertical, horizontal }} open={open} autoHideDuration={TOAST_SHOW_DURATION} onClose={handleClose}>
        <Slide direction="down" in={true} >
          <div>
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error" >
              {msg}
            </Alert>
          </div>
        </Slide>
      </Snackbar>
    </div>
  );
}